interface TynHubBylineProps {
  className?: string
}

export function TynHubByline({ className = '' }: TynHubBylineProps) {
  return (
    <span className={`text-xs text-gray-400 dark:text-gray-500 ${className}`}>
      by{' '}
      <a
        href="https://tynhub.com"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-primary-600 hover:text-primary-500 dark:text-primary-400 dark:hover:text-primary-300"
      >
        TynHub
      </a>
    </span>
  )
}
